var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.displayPanel
    ? _c("CompassPanel", {
        staticClass: "panel-create-activity",
        attrs: { value: true, title: _vm.panelTitle, icon: _vm.panelIcon },
        on: { beforeClose: _vm.onClosePanel },
        scopedSlots: _vm._u(
          [
            {
              key: "default",
              fn: function() {
                return [
                  _vm.isLoading
                    ? _c("ActivityDetailPanelContentLoadingState")
                    : [
                        _c(
                          "h3",
                          {
                            staticClass:
                              "panel-create-activity__content-title typographies-heading-h2"
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.localizedTexts.contentTitle) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "panel-create-activity__form" },
                          [
                            _c(
                              "CompassFormItem",
                              {
                                attrs: {
                                  label: _vm.$t.__("common.labels.title"),
                                  orientation: "horizontal",
                                  size: "small"
                                }
                              },
                              [
                                _c("CompassInput", {
                                  ref: "inputTitle",
                                  attrs: {
                                    placeholder:
                                      _vm.localizedTexts
                                        .placeholderActivityTitle
                                  },
                                  model: {
                                    value: _vm.activityFormData.title,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.activityFormData,
                                        "title",
                                        $$v
                                      )
                                    },
                                    expression: "activityFormData.title"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "CompassDescriptionList",
                              { attrs: { type: "alternative" } },
                              [
                                _c(
                                  "CompassDescriptionListItem",
                                  {
                                    attrs: {
                                      label: _vm.localizedTexts.priority
                                    }
                                  },
                                  [
                                    _c("ActivitiesPriorityIconButton", {
                                      attrs: {
                                        isActive: _vm.activityIsPrioritized,
                                        enabled: ""
                                      },
                                      on: { clicked: _vm.togglePriority }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "CompassFormItem",
                              {
                                attrs: {
                                  label: _vm.localizedTexts.label,
                                  orientation: "horizontal",
                                  size: "small"
                                }
                              },
                              [
                                _c(
                                  "CompassSelect",
                                  {
                                    attrs: {
                                      menuClass: "select-labels-activity"
                                    },
                                    model: {
                                      value: _vm.activityFormData.label_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.activityFormData,
                                          "label_id",
                                          $$v
                                        )
                                      },
                                      expression: "activityFormData.label_id"
                                    }
                                  },
                                  _vm._l(_vm.labelsOptions, function(label) {
                                    return _c("CompassDropdownSelectOption", {
                                      key: label.id,
                                      attrs: {
                                        label: label.label,
                                        dotColor: label.color,
                                        value: label.id,
                                        type: "dot"
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.dateFormComponent
                              ? _c(_vm.dateFormComponent, {
                                  tag: "component",
                                  attrs: {
                                    activityDate: _vm.activityDate,
                                    workingDays: _vm.metas.working_days,
                                    workingHours: _vm.metas.working_hours,
                                    activityData: _vm.activityData
                                  },
                                  on: {
                                    updateFormIsInvalid: function(value) {
                                      return (_vm.formIsInvalid = value)
                                    },
                                    "update:activityDate": function(value) {
                                      return (_vm.activityDate = value)
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "CompassFormItem",
                              {
                                attrs: {
                                  label: _vm.$t.__("common.labels.assignee"),
                                  orientation: "horizontal",
                                  size: "small"
                                }
                              },
                              [
                                _c(
                                  "CompassSelect",
                                  {
                                    attrs: {
                                      filterable: true,
                                      menuClass: "select-staffs-activity"
                                    },
                                    model: {
                                      value: _vm.activityFormData.owner_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.activityFormData,
                                          "owner_id",
                                          $$v
                                        )
                                      },
                                      expression: "activityFormData.owner_id"
                                    }
                                  },
                                  _vm._l(_vm.availableOwner, function(staff) {
                                    return _c("CompassDropdownSelectOption", {
                                      key: staff.id,
                                      attrs: {
                                        label:
                                          staff.firstname +
                                          " " +
                                          staff.lastname,
                                        value: staff.id,
                                        type: "avatar",
                                        disabled: staff.disabled,
                                        avatar: _vm.getAvatarObject(
                                          staff.firstname,
                                          staff.lastname,
                                          staff.avatar
                                        )
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "CompassFormItem",
                              {
                                attrs: {
                                  label: _vm.$t.__(
                                    "common.labels.select_other_staff"
                                  ),
                                  orientation: "horizontal",
                                  size: "small"
                                }
                              },
                              [
                                _c(
                                  "CompassSelect",
                                  {
                                    ref: "selectAssignedStaff",
                                    attrs: {
                                      multiple: true,
                                      filterable: true,
                                      placeholder: _vm.$t.__(
                                        "common.labels.search_several_staff"
                                      ),
                                      menuClass: "select-staffs-activity"
                                    },
                                    model: {
                                      value: _vm.activityFormData.staffs,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.activityFormData,
                                          "staffs",
                                          $$v
                                        )
                                      },
                                      expression: "activityFormData.staffs"
                                    }
                                  },
                                  _vm._l(_vm.availableAssignedStaff, function(
                                    staff
                                  ) {
                                    return _c("CompassDropdownSelectOption", {
                                      key: staff.id,
                                      attrs: {
                                        label:
                                          staff.firstname +
                                          " " +
                                          staff.lastname,
                                        value: staff.id,
                                        type: "avatar",
                                        disabled: staff.disabled,
                                        avatar: _vm.getAvatarObject(
                                          staff.firstname,
                                          staff.lastname,
                                          staff.avatar
                                        )
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.shouldDisplayContactInput
                              ? _c(
                                  "CompassFormItem",
                                  {
                                    staticClass: "contacts-input-label",
                                    attrs: {
                                      label: _vm.localizedTexts.contacts,
                                      orientation: "horizontal",
                                      size: "small"
                                    }
                                  },
                                  [
                                    _c("ActivityFormPanelContactInput", {
                                      attrs: {
                                        contacts: _vm.activityFormData.contacts,
                                        dataFromAutocomplete:
                                          _vm.dataFromAutocomplete,
                                        isDropdownLoading:
                                          _vm.isDropdownLoading,
                                        embedParticipants: _vm.embedParticipants
                                      },
                                      on: {
                                        "update:contacts": _vm.updateContacts,
                                        input: _vm.getDataFromAutocomplete
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "CompassFormItem",
                              {
                                attrs: {
                                  label: _vm.localizedTexts.description,
                                  orientation: "vertical",
                                  size: "small"
                                }
                              },
                              [
                                _c("RichText", {
                                  staticClass: "description-input-max-height",
                                  attrs: { options: _vm.optionsRichText },
                                  model: {
                                    value: _vm.activityFormData.description,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.activityFormData,
                                        "description",
                                        $$v
                                      )
                                    },
                                    expression: "activityFormData.description"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "CompassAccordion",
                              {
                                attrs: {
                                  title: _vm.$t.__(
                                    "activities.activitiesFormPanel.linked_object"
                                  ),
                                  open: "",
                                  variant: "h2"
                                }
                              },
                              [
                                !_vm.activityFormData.related.length
                                  ? _c("CompassButton", {
                                      attrs: {
                                        label: _vm.$t.__(
                                          "activities.dialog.ActivitiesLinkObjectDialog.link_object_title"
                                        ),
                                        type: "tertiary",
                                        leftIcon: "objects-linked"
                                      },
                                      on: {
                                        click: _vm.handleOpenLinkObjectDialog
                                      }
                                    })
                                  : _c("LinkedObject", {
                                      attrs: {
                                        object:
                                          _vm.activityFormData.related[0]
                                            .object,
                                        name:
                                          _vm.activityFormData.related[0].name,
                                        link:
                                          _vm.activityFormData.related[0].link,
                                        isRemovable: true
                                      },
                                      on: {
                                        remove: function($event) {
                                          _vm.activityFormData.related = []
                                        },
                                        onClickLinkedObject:
                                          _vm.handleOpenLinkObjectDialog
                                      }
                                    })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "CompassAccordion",
                              {
                                staticClass:
                                  "panel-create-activity__form-advanced-settings",
                                attrs: {
                                  title: _vm.$t.__(
                                    "common.labels.advanced_settings"
                                  ),
                                  variant: "h2",
                                  open: ""
                                }
                              },
                              [
                                _c(
                                  "CompassFormItem",
                                  {
                                    attrs: {
                                      label: _vm.localizedTexts.privacy.title,
                                      orientation: "horizontal",
                                      size: "small",
                                      inputSize: "none"
                                    }
                                  },
                                  [
                                    _c(
                                      "CompassRadioGroup",
                                      {
                                        attrs: {
                                          label: "",
                                          direction: "horizontal"
                                        },
                                        model: {
                                          value: _vm.privacy,
                                          callback: function($$v) {
                                            _vm.privacy = $$v
                                          },
                                          expression: "privacy"
                                        }
                                      },
                                      [
                                        _c("CompassRadio", {
                                          attrs: {
                                            modelValue: "public",
                                            label:
                                              _vm.localizedTexts.privacy.public
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("CompassRadio", {
                                          attrs: {
                                            modelValue: "private",
                                            label:
                                              _vm.localizedTexts.privacy.private
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.activityType === _vm.ACTIVITY_TYPE.TASK
                                  ? _c("ActivityFormPanelReminder", {
                                      attrs: {
                                        reminders:
                                          _vm.activityFormData.reminders,
                                        isEditMode: !!_vm.activityData,
                                        displayReminderNotifInApp: ""
                                      },
                                      on: {
                                        updateActivityReminder: function(
                                          reminders
                                        ) {
                                          return (_vm.activityFormData.reminders = reminders)
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                ]
              },
              proxy: true
            },
            {
              key: "footer",
              fn: function() {
                return [
                  !_vm.isLoading
                    ? _c(
                        "div",
                        { staticClass: "panel-create-activity__footer" },
                        [
                          _c("CompassButton", {
                            attrs: {
                              label: _vm.localizedTexts.cancelBtn,
                              type: "secondary",
                              disabled: _vm.saveIsPending
                            },
                            on: { click: _vm.onClosePanel }
                          }),
                          _vm._v(" "),
                          _c("CompassButton", {
                            attrs: {
                              label: _vm.localizedTexts.saveBtn,
                              loading: _vm.saveIsPending,
                              disabled: _vm.formIsInvalid
                            },
                            on: { click: _vm.onSave }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              },
              proxy: true
            }
          ],
          null,
          false,
          935439139
        )
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }